import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { PlusOutlined } from '@ant-design/icons'
import { Tabs, Form, Row, Col, Select, Modal } from 'antd';
import Input from '../../../../../ui/Input';
import PageContainer from "../../../../../CSIComponents/PageContainer";
import { getOTACodes } from "../../../../../../services/common";
import {statesList} from '../constants/statesList'
const { TabPane } = Tabs;
const { Option } = Select;
let newTabIndex = 0;

interface Pane {
  id: string
  name: string
  type: string
  pobox: string
  address: Array<{text: string}>
  city: string
  state: string
  country: string
  postalcode: string
}
const PaymentAddressEdit = forwardRef((props: any, paymentAddressEditRef: any) => {
  const [states] = useState<string[]>(statesList)
  const rowDetail = JSON.parse(JSON.stringify(props.cancellationDetails))
  const [form]: any = Form.useForm()
  useImperativeHandle(paymentAddressEditRef, () => ({ paymentAddressForm: form, resetRequired: (param: boolean) => { 
    //setIsRequired(param) 
  } }))
  const initialPanes: any = rowDetail.paymentaddress ? rowDetail.paymentaddress : []
  const [isRequired, setIsRequired] = useState(true)

  initialPanes.forEach((item: any, index: number) => {
    const address: any = []
    const addressItem = Object.keys(item).filter((item1, index) => {
      return (item1 + '').startsWith('addressline')
    })
    addressItem.forEach((item2) => {
      if (item[item2] !== '' && item[item2] !== null) {
        address.push({ text: item[item2] })
      }
    })
    if (address.length === 0) {
      address.push({ text: '' })
    }
    item.address = address;
    item.id = index + 1 + '';
    item.closable = true;
  })
  if (initialPanes.length === 1) {
    initialPanes[0].closable = true;
  }
  const [activeKey, setActiveKey] = useState(initialPanes.length != 0 ? initialPanes[0].id : 0)
  const [panes, setPanels] = useState(initialPanes)

  const onChange = (activeKey: any) => {
    setActiveKey(activeKey)
  };
  const onEdit = (
    targetKey:
      | string
      | React.MouseEvent<Element, MouseEvent>
      | React.KeyboardEvent<Element>,
    action: 'add' | 'remove',
  ) => {
    switch (action) {
      case 'add':
        return add()
      case 'remove':
        return remove(targetKey)
    }
  }

  const add = () => {
    setIsRequired(true);
    const newKey = ++newTabIndex;
    const newPanes = JSON.parse(JSON.stringify(panes));
    newPanes.push(
      {
        name: 'Payment Address ' + newKey,
        content: 'Content of new Tab',
        id: newKey + '',
        address: [{ text: '' }],
        closable: true
      }
    );
    newPanes[0].closable = true;
    setPanels(newPanes)
    setActiveKey(JSON.stringify(newKey))
  };
  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }
  const remove = (targetKey: any) => {
    let deleteTabName = panes.filter((item: any) => targetKey == item.id)
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete Payment Address ${deleteTabName[0].id} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      transitionName: '',
      maskTransitionName: '',
      onOk() {
        if (panes.length === 1) {
          form.resetFields()
          setIsRequired(false)
          props.validateFieldsError();
        } else {
          let newActiveKey = activeKey;
          let lastIndex: any;
          panes.forEach((pane: any, i: any) => {
            if (pane.id == targetKey) {
              lastIndex = i - 1;
            }
          });
          const newPanes = JSON.parse(JSON.stringify(panes.filter((pane: any) => pane.id !== targetKey)));
          if (newPanes.length && newActiveKey === targetKey) {
            if (lastIndex >= 0) {
              newActiveKey = newPanes[lastIndex].id;
            } else {
              newActiveKey = newPanes[0].id;
            }
          }
          if (newPanes.length === 1) {
            newPanes[0].closable = true;
          }
          setPanels(newPanes)
          setActiveKey(newActiveKey)
        }
      },
      onCancel() {

      },
    });
  };
  const addAddress = (index: number) => {

    setIsRequired(true);
    //panes[index].address.push({ text: '' })
    //panes[index].address = [...panes[index].address]
    let _panes = JSON.parse(JSON.stringify(panes));
    _panes[index].address.push({ text: '' })
    setPanels(_panes)
  }
  const deleteAddress = (index: number, id: string) => {
    const newPanes = JSON.parse(JSON.stringify(panes))
    const addressLastName = "address-" + id + '**' + newPanes[index].address.length
    newPanes[index].address = [...newPanes[index].address.slice(0, newPanes[index].address.length - 1)];
    form.setFieldsValue({ [addressLastName]: '' })
    setPanels([...newPanes])
  }

  const [autData, setAutData] = useState([])
  const getAutData = async () => {
    const { otacodes = [] } = await getOTACodes('AUT', '')
    if (otacodes && otacodes.length > 0) setAutData(otacodes)
    else setAutData([])
  }

  const [couData, setCouData] = useState([])
  const getCouData = async () => {
    const { otacodes = [] } = await getOTACodes('COU', '')
    if (otacodes && otacodes.length > 0) setCouData(otacodes)
    else setCouData([])
  }
  
  useEffect(() => {
    getCouData();
    getAutData();
    if (rowDetail.paymentaddress.length === 0) {
      add()
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  useEffect(() => {
    props?.accPayEditRef?.current?.resetRequired(false);
    setIsRequired(true);
    props.validateFieldsError();
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [panes])

    const getInitialValues = () => ({
      ...panes.reduce(
        (acc: Object, pane: Pane) => ({
          ...acc,
          [`addname-${pane.id}`]: pane.name,
          [`type-${pane.id}`]: pane.type,
          [`pobox-${pane.id}`]: pane.pobox,
          ...pane.address.reduce(
            (acc: any, { text }, i: number) => ({
              ...acc,
              [`address-${pane.id}**${i + 1}`]: text,
            }),
            {},
          ),
          [`city-${pane.id}`]: pane.city,
          [`state-${pane.id}`]: pane.state,
          [`country-${pane.id}`]: pane.country,
          [`postalcode-${pane.id}`]: pane.postalcode,
        }),
        {},
      ),
    })

  return (
    <>
      <PageContainer style={{ marginBottom: '90px' }}>
        <div style={{ background: '#fff', padding: '20px 10px 20px 0' }}>
          <Form
            layout="vertical"
            form={form}
            name="basic"
            onValuesChange={(changedFields, allFields) => {
              setIsRequired(true);
              props.validateFieldsError();
            }}
            initialValues={getInitialValues()}
          >
            <Tabs
              type="editable-card"
              onChange={onChange}
              activeKey={activeKey}
              onEdit={onEdit}

            >
              {panes.map((pane: any, i: number) => (
                <TabPane tab={'Payment Address ' + pane.id} closable={pane.closable} key={pane.id} forceRender={true}>
                  <PageContainer>
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          label="Address Name"
                          name={`addname-${pane.id}`}
                          rules={[{ max: 64, message: 'You have reached the max character length of 64' }]}
                        >
                          <Input maxLength={64} />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Address Type"
                          name={`type-${pane.id}`}
                          rules={[{ required: false, message: 'This field is required' }]}
                        >
                          <Select allowClear showSearch
                            optionFilterProp="children"
                            // @ts-expect-error
                            filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {autData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="PO Box"
                          name={`pobox-${pane.id}`}
                          rules={[{ max: 32, message: 'You have reached the max character length of 32' }]}
                        >
                          <Input maxLength={32} />
                        </Form.Item>
                      </Col>
                    </Row>
                    {pane?.address?.map((address: any, index: number) => {
                      return <Row gutter={24} key={index}>
                        <Col span={18}>
                          <Form.Item
                            label={"Address" + (index + 1)}
                            name={`address-${pane.id}**${index + 1}`}
                            rules={[{ required: false, message: 'This field is required' },
                            { max: 64, message: 'You have reached the max character length of 64' }]}
                          >
                            <Input maxLength={64} value={address} />
                          </Form.Item>
                        </Col>
                        <Col span={6}></Col>
                      </Row>
                    })}
                    <Row gutter={24} >
                      <Col span={18} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        {pane?.address?.length < 4 && <div style={{ color: '#004771', display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => addAddress(i)}><PlusOutlined style={{ marginRight: 4 }} />Add Address {pane?.address?.length + 1}</div>}
                        {pane?.address?.length > 1 && <div style={{ color: '#f07171', marginLeft: 20, cursor: 'pointer' }} onClick={() => { deleteAddress(i, pane.id) }}>Delete</div>}
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="City"
                          name={`city-${pane.id}`}
                          rules={[{ max: 64, message: 'You have reached the max character length of 64' }]}
                        >
                          <Input maxLength={64} />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                          <Form.Item
                                  label="State"
                                  name={`state-${pane.id}`}
                            >
                              <Select allowClear showSearch
                                  defaultValue={pane.state}>
                                  {
                                      states.map((state: string, index: number) => (
                                      <Option value={state} key={index}>{state}</Option>
                                      ))
                                  }
                              </Select>
                            </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Country"
                          name={`country-${pane.id}`}
                        >
                          <Select allowClear showSearch
                            optionFilterProp="children"
                            // @ts-expect-error
                            filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {couData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="Postal Code"
                          name={`postalcode-${pane.id}`}
                          rules={[{max: 10, message: 'You have reached the max character length of 10' }]}
                        >
                          <Input maxLength={10} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </PageContainer>
                </TabPane>
              ))}
            </Tabs>
          </Form>
        </div>
      </PageContainer>
    </>
  )
})

export default PaymentAddressEdit
